import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const techStack = [
  { name: 'Vue.js', category: 'Frontend' },
  { name: 'Python', category: 'Backend' },
  { name: 'Node.js', category: 'Backend' },
  { name: 'AWS', category: 'Cloud' },
  { name: 'Docker', category: 'DevOps' },
  { name: 'Kubernetes', category: 'DevOps' },
  { name: 'PostgreSQL', category: 'Database' },
  { name: 'MongoDB', category: 'Database' },
  { name: 'Redis', category: 'Cache' },
  { name: 'GraphQL', category: 'API' },
  { name: 'Berri.js', category: 'Framework'},
  { name: 'TypeScript', category: 'Frontend' },
  { name: 'Terraform', category: 'Infrastructure' },
];

const benefits = [
  'Enterprise Security',
  'Agile Development',
  'Continuous Deployment',
  '24/7 Support',
  'Full Documentation',
  'Knowledge Transfer'
];

export const TechStackSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-24 md:py-32 bg-[#003333] overflow-hidden" data-testid="tech-stack-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-4">
            Technology
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white max-w-3xl mx-auto">
            Modern Stack, Proven Results
          </h2>
        </motion.div>
        
        {/* Tech Stack Marquee */}
        <div className="marquee-container mb-16 py-8 border-y border-white/10">
          <div className="marquee-content">
            {[...techStack, ...techStack].map((tech, index) => (
              <div 
                key={index}
                className="inline-flex items-center gap-3 mx-8 text-white/60 hover:text-white transition-colors"
              >
                <span className="text-2xl md:text-3xl font-semibold">{tech.name}</span>
                <span className="text-xs uppercase tracking-wider opacity-50">{tech.category}</span>
              </div>
            ))}
          </div>
        </div>
        
        {/* Benefits */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="flex flex-wrap justify-center gap-4 md:gap-6"
        >
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
              className="px-6 py-3 bg-white/5 border border-white/10 rounded-full text-white/80 text-sm font-medium hover:bg-white/10 transition-colors"
              data-testid={`benefit-${index}`}
            >
              {benefit}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
